/* eslint-disable max-len */

import { client } from '../../../../../common-utils/libraries/axios/axios';
import { replaceParameters } from '@/common-utils/functions/restUtils';
import simGroupFields from '../../fields/simGroupFields';
import { SIMS_GROUP } from '../apiUrls';
import getObjectAttributeFromStringKey from '@/common-utils/functions/getObjectAttributeFromStringKey';
import generateNestedFieldAccessor from '@/common-utils/functions/generateNestedFieldAccessor';


/**
 * @param responseData response.data object
 * @param responseData.activatedSims number
 * @param responseData.consumptionPercentage number
 * @param responseData.monthlyConsumption number
 * @param responseData.organization string
 * @param responseData.simProvider string
 * @param responseData.tariffDataUnit string
 * @param responseData.organizationUuid string
 * @param responseData.tariffData number
 * @param responseData.totalData number
 * @param response
 * @param responseData.items
 * @param responseData.totalResults
 * @returns Mapped data object
 */
function mapResponseData(response) {
    const data = {};


    data[simGroupFields.ORGANIZATION.key] = response[simGroupFields.ORGANIZATION.key];
    data[simGroupFields.PROVIDER.key] = response[simGroupFields.PROVIDER.key];
    data[simGroupFields.TOTAL_ACTIVATED_SIMS.key] = response[simGroupFields.TOTAL_ACTIVATED_SIMS.key];
    data[simGroupFields.SIM_OFFER.key] = {
        [simGroupFields.SIM_OFFER.DATA.key]: getObjectAttributeFromStringKey(response, generateNestedFieldAccessor(simGroupFields.SIM_OFFER.DATA)),
        [simGroupFields.SIM_OFFER.DATA_UNIT.key]: getObjectAttributeFromStringKey(response, generateNestedFieldAccessor(simGroupFields.SIM_OFFER.DATA_UNIT))
    };

    const dataUsage = response[simGroupFields.DATA_USAGE.key].map(item => {
        return {
            [simGroupFields.MONTH_YEAR.key]: item[simGroupFields.MONTH_YEAR.key],
            [simGroupFields.DATA_CONSUMPTION.key]: item[simGroupFields.DATA_CONSUMPTION.key]
        };
    });

    data[simGroupFields.DATA_USAGE.key] = dataUsage;
    return data;
}

const queryGetSimGroupDetails = (groupId, enabled) => {
    return {
        queryKey: [SIMS_GROUP.DETAILS.queryKey, groupId],
        queryFn: async () => {
            const response = await client.get(replaceParameters(SIMS_GROUP.DETAILS.url, { simPoolUuid: groupId }));
            return mapResponseData(response.data);
        },
        enabled: enabled
    };
};


export default queryGetSimGroupDetails;